export const SETTINGS = {
	disabled: false,
	isToggle: false,
	selected: false,
	toggleClass: '',
	value: '',
};
